<form #form="ngForm">
    <ng-container *ngIf="review">
        <div class="responsive-grid">
            <app-segment-header title="performance.review-details-edit.headerTitle"></app-segment-header>
            <div class="row">
                <mat-form-field>
                    <mat-label>{{ 'performance.review-details-edit.formFields.title.label' | translate }}</mat-label>
                    <input
                        matInput
                        type="text"
                        name="title"
                        required
                        placeholder="{{ 'performance.review-details-edit.formFields.title.placeholder' | translate }}"
                        #title="ngModel"
                        [(ngModel)]="review.title"
                    />
                    <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>{{ 'performance.review-details-edit.formFields.reviewee.label' | translate }}</mat-label>
                    <ui-employee-autocomplete
                        name="subjectId"
                        [required]="true"
                        #subjectId="ngModel"
                        [ngModel]="review.subject"
                        (ngModelChange)="review.subjectId = $event.id; onSubjectChange($event)"
                    ></ui-employee-autocomplete>
                    <mat-error *ngIf="subjectId.invalid">{{ subjectId.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{
                    'performance.review-details-edit.formFields.frequency.label' | translate
                }}</mat-label>
                <mat-select name="reoccuring" [(ngModel)]="review.reoccuring">
                    <mat-option value="">{{
                        'performance.review-details-edit.formFields.frequency.options.selectAnOption' | translate
                    }}</mat-option>
                    <mat-option value="never">{{
                        'performance.review-details-edit.formFields.frequency.options.once' | translate
                    }}</mat-option>
                    <mat-option value="weekly">{{
                        'performance.review-details-edit.formFields.frequency.options.weekly' | translate
                    }}</mat-option>
                    <mat-option value="monthly">{{
                        'performance.review-details-edit.formFields.frequency.options.monthly' | translate
                    }}</mat-option>
                    <mat-option value="quarterly">{{
                        'performance.review-details-edit.formFields.frequency.options.quarterly' | translate
                    }}</mat-option>
                    <mat-option value="semiannually">{{
                        'performance.review-details-edit.formFields.frequency.options.semiannually' | translate
                    }}</mat-option>
                    <mat-option value="annually">{{
                        'performance.review-details-edit.formFields.frequency.options.annually' | translate
                    }}</mat-option>
                </mat-select>
            </mat-form-field>

            <app-segment-header
                title="performance.review-details-edit.responsesAccessSectionTitle"
            ></app-segment-header>
            <span style="text-align: left; padding-bottom: 16px">
                {{ 'performance.review-details-edit.responsesAccessSectionDescription' | translate }}
            </span>

            <ng-container *ngIf="performanceReviewImprovements">
                <div class="padding-bottom-2">
                    <div class="padding-bottom-1 flex">
                        <strong>{{ 'performance.bulk-review.responseAccess.directManagersLabel' | translate }}</strong>
                        <ui-info
                            class="margin-left-1"
                            text="performance.bulk-review.responseAccess.directManagerSettingTooltip"
                        ></ui-info>
                    </div>
                    <mat-radio-group
                        name="viewResultsBeforeCompletion"
                        class="vertical"
                        [(ngModel)]="review.viewResultsBeforeCompletion"
                    >
                        <mat-radio-button class="margin-bottom-1" [value]="false">{{
                            'performance.bulk-review.responseAccess.directManagersCanSeeResponsesOnceCompleted'
                                | translate
                        }}</mat-radio-button>
                        <mat-radio-button [value]="true">{{
                            'performance.bulk-review.responseAccess.directManagersCanAlwaysSeeResponses' | translate
                        }}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </ng-container>

            <div class="padding-bottom-2 flex">
                <mat-checkbox
                    (change)="trackMakingResponsesVisibleToReviewee()"
                    [(ngModel)]="review.subjectCanViewResults"
                    name="subjectCanViewResults"
                    #subjectCanViewResults="ngModel"
                >
                    {{
                        'performance.review-details-edit.formFields.responsesAccess.revieweeAccessLabel'
                            | translate
                                : {
                                      revieweeName: review.subject?.fullName || 'reviewee',
                                  }
                    }}
                </mat-checkbox>
                <mat-error *ngIf="subjectCanViewResults?.errors">{{
                    subjectCanViewResults?.errors | formErrors
                }}</mat-error>
            </div>
            <div class="padding-bottom-2 flex">
                <mat-checkbox
                    (change)="trackMakingResponsesVisibleToOthers()"
                    [(ngModel)]="review.participantsCanViewResults"
                    name="participantsCanViewResults"
                    #participantsCanViewResults="ngModel"
                >
                    {{
                        'performance.review-details-edit.formFields.responsesAccess.participantsAccessLabel' | translate
                    }}
                </mat-checkbox>
                <mat-error *ngIf="participantsCanViewResults?.errors">{{
                    participantsCanViewResults?.errors | formErrors
                }}</mat-error>
            </div>

            <app-segment-header title="performance.review-details-edit.scheduleSectionTitle"></app-segment-header>
            <div class="row">
                <mat-form-field>
                    <mat-label>{{
                        'performance.review-details-edit.formFields.reviewDate.startDate' | translate
                    }}</mat-label>
                    <input
                        matInput
                        name="scheduleAt"
                        required
                        #scheduleAt="ngModel"
                        [ngModel]="review.scheduleAt | appDate: 'yyyy-MM-dd'"
                        (ngModelChange)="review.scheduleAt = $event"
                        placeholder="{{
                            'performance.review-details-edit.formFields.reviewDate.placeholder' | translate
                        }}"
                        [matDatepicker]="scheduleAtPicker"
                    />
                    <mat-datepicker-toggle matSuffix [for]="scheduleAtPicker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #scheduleAtPicker></mat-datepicker>
                    <mat-error *ngIf="scheduleAt.invalid">{{ scheduleAt.errors | formErrors }}</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ 'performance.review-details-edit.formFields.dueDate.label' | translate }}</mat-label>
                    <input
                        matInput
                        name="dueAt"
                        #dueAt="ngModel"
                        [ngModel]="review.dueAt | appDate: 'yyyy-MM-dd'"
                        (ngModelChange)="review.dueAt = $event"
                        placeholder="{{ 'performance.review-details-edit.formFields.dueDate.placeholder' | translate }}"
                        [matDatepicker]="dueAtPicker"
                        required
                    />
                    <mat-datepicker-toggle matSuffix [for]="dueAtPicker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #dueAtPicker></mat-datepicker>
                    <mat-error *ngIf="dueAt.invalid">{{ dueAt.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>

            <app-segment-header title="performance.review-details-edit.reviewPeriodTitle"></app-segment-header>
            <div class="row">
                <mat-form-field>
                    <mat-label>{{
                        'performance.review-details-edit.formFields.periodStartDate.label' | translate
                    }}</mat-label>
                    <input
                        matInput
                        name="periodStart"
                        required
                        #periodStart="ngModel"
                        [ngModel]="review.periodStart | appDate: 'yyyy-MM-dd'"
                        (ngModelChange)="review.periodStart = $event"
                        placeholder="{{
                            'performance.review-details-edit.formFields.periodStartDate.placeholder' | translate
                        }}"
                        [matDatepicker]="periodStartPicker"
                        [max]="review.periodEnd | appDate: 'yyyy-MM-dd'"
                    />
                    <mat-datepicker-toggle matSuffix [for]="periodStartPicker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #periodStartPicker></mat-datepicker>
                    <mat-error *ngIf="periodStart.invalid">
                        <span *ngIf="periodStart.errors?.matDatepickerMax">{{
                            'dateValidation.dateMustBeBefore'
                                | translate: { date: review.periodEnd | appDate: 'yyyy-MM-dd' }
                        }}</span>
                        <span>{{ periodEnd.errors | formErrors }}</span>
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{
                        'performance.review-details-edit.formFields.periodEndDate.label' | translate
                    }}</mat-label>
                    <input
                        matInput
                        name="periodEnd"
                        #periodEnd="ngModel"
                        [ngModel]="review.periodEnd | appDate: 'yyyy-MM-dd'"
                        (ngModelChange)="review.periodEnd = $event"
                        placeholder="{{
                            'performance.review-details-edit.formFields.periodEndDate.placeholder' | translate
                        }}"
                        [matDatepicker]="periodEndPicker"
                        required
                        [min]="review.periodStart | appDate: 'yyyy-MM-dd'"
                    />
                    <mat-datepicker-toggle matSuffix [for]="periodEndPicker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #periodEndPicker></mat-datepicker>
                    <mat-error *ngIf="periodEnd.invalid">
                        <span *ngIf="periodEnd.errors?.matDatepickerMin">{{
                            'dateValidation.dateMustBeTheSameOrAfter'
                                | translate: { date: review.periodStart | appDate: 'yyyy-MM-dd' }
                        }}</span>
                        <span>{{ periodEnd.errors | formErrors }}</span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </ng-container>
</form>
